import urljoin from 'url-join';
import axios from 'axios';

import { store } from '../store';

const LinkObfuscate = {
	getLink(url) {
		const state = store.getState();
		const apiRoute = state.config.routes.api.router;
		const linkObfucaste = state.data.obfuscate;

		if (typeof linkObfucaste[url] !== "undefined") {
			return;
		}
		axios.get(urljoin(apiRoute, url))
			.then((response) => {
				store.dispatch({
					type: 'LINKOBFUSCATE_UPDATE_LINKS',
					payload: {
						data: response.data,
						id: url,
					},
				});
			});
	},
	redirect(ruta) {
		const { url, blank } = store.getState().data.obfuscate[ruta];
		window.open(url, blank ? "_blank" : "_self");
	},
};

export default LinkObfuscate;
